<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open" @click="passDone()">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content"  style="text-align:center;color:red;">
                        <slot />
                       <!--<br><br>                        
                       <p class="h3 text-seccess fw-bold"> {{this.popupMessage}}</p>
                       <br>-->
                        <div style="align:center;vertical-align:middle;height: 100%">
                            <br>
                            <br>
                            <span v-for="item in msgItems" :key="item.id"><p class="h1 text-seccess fw-bold" style="color: red; font-size: 500%; font-weight: 700;"> {{item.cont}}</p></span>
                            <!--<button @click="passDone()" class="btn btn-primary" style="width: 100%; height: 100%; background-color: white;"><span v-for="item in msgItems" :key="item.id"><p class="h1 text-seccess fw-bold" style="color: red; font-size: 500%; font-weight: 700;"> {{item.cont}}</p></span></button>-->
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>
import commonServices from "@/shared/commonServices"

export default {
    mixins: [commonServices],
    name:"ShowInfos",
    data: function(){
        return {
            done:true
        }
    },
    
    methods:{  
        passDone()
        {
            this.$emit('returnChangeDone', this.done)
            this.close();
        },
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
        popupMessage: {
            type:String,
            required:true
        },     
        msgItems: {
            type:Array,
            required:true
        },     
           
    },
    setup(_, { emit }){   
        const close = () => {
            emit('close');
        };
        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
}
.vue-modal-inner {
    max-width: 100%;
    max-height: 100%;
    height: 80%;
    margin: 2rem auto;
}
.vue-modal-content {
    position: relative;
    background-color: var(--form-color);
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    height: 100%;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
/*
@import "https://unpkg.com/primitive-ui/dist/css/main.css"
*/

</style>
